module.exports = __webpack_public_path__ + "img/node_7.8dcb5056.png";